var map = {
	"./gameOperationsAnalysis.svg": 73923,
	"./operationsStatistics.svg": 88562,
	"./payType.svg": 42420,
	"./pointDeduction.svg": 82427,
	"./recharge.svg": 12103,
	"./store.svg": 5762,
	"./storeOperationsChart.svg": 61654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49595;